import React from "react";
import MListItemIcon from '@mui/material/ListItemIcon';

const ListItemIcon = (props) => {
    return (
        <MListItemIcon {...props} />
    )
}

export default React.memo(ListItemIcon);